import axios from "axios";

// 根据环境自动选择 baseURL
// 本地开发时使用 localhost:8080，生产环境使用线上地址
const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://allcprmanage.com"
    : "http://localhost:8080";

// 创建一个axios实例
const axiosInstance = axios.create({
  baseURL: baseURL,
});

const SESSION_TIMEOUT_MS = 9 * 60 * 60 * 1000; // 9 hours
const SESSION_LAST_ACTIVITY_KEY = "session_last_activity_at";
let isSessionTimeoutHandling = false;

const updateSessionActivity = () => {
  sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, Date.now().toString());
};

const isSessionExpired = () => {
  const lastActivity = Number(sessionStorage.getItem(SESSION_LAST_ACTIVITY_KEY));
  if (!lastActivity) {
    updateSessionActivity();
    return false;
  }

  return Date.now() - lastActivity > SESSION_TIMEOUT_MS;
};

const handleSessionTimeout = () => {
  if (isSessionTimeoutHandling) {
    return;
  }

  isSessionTimeoutHandling = true;
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  sessionStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
  window.alert("Session timed out. Please sign in again.");
  window.location.href = "/";
};

export const initializeSessionActivityTracker = () => {
  const events = [
    "mousemove",
    "mousedown",
    "keydown",
    "scroll",
    "touchstart",
    "click",
  ];

  const onActivity = () => {
    if (localStorage.getItem("token")) {
      updateSessionActivity();
    }
  };

  events.forEach((eventName) => {
    window.addEventListener(eventName, onActivity);
  });

  if (localStorage.getItem("token")) {
    updateSessionActivity();
  } else {
    sessionStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
  }

  return () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, onActivity);
    });
  };
};

// 添加请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 从localStorage中获取令牌
    const token = localStorage.getItem("token");
    if (token) {
      if (isSessionExpired()) {
        handleSessionTimeout();
        return Promise.reject(new axios.CanceledError("Session timed out"));
      }

      // 在请求头中添加令牌
      config.headers["Authorization"] = `Bearer ${token}`;
      updateSessionActivity();
      //console.log("nihao"+token);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (localStorage.getItem("token")) {
      updateSessionActivity();
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if ((status === 401 || status === 403) && localStorage.getItem("token")) {
      handleSessionTimeout();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
